export default "__VITE_ASSET__b0b1d075__"